import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadProgressComponent } from 'src/app/shared/components/upload-progress/upload-progress.component';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { ImageCropperComponent } from 'src/app/shared/components/image-cropper/image-cropper.component';
@Component({
  selector: 'app-success-projects-images',
  templateUrl: './success-projects-images.component.html',
  styleUrls: ['./success-projects-images.component.css']
})
export class SuccessProjectsImagesComponent implements OnInit {

  @Output() showNextPage: EventEmitter<number> = new EventEmitter();
  successPropertyImages: Array<string> = [
    '',
    '',
    '',
    '',
    '',
    ''
  ];
  selectedProperty: any;

  constructor(
    private modalService: NgbModal,
    private rsbService: RsbService,
    private lookupModel: RsbLookupModel
  ) { }

  ngOnInit(): void {
    this.selectedProperty = this.lookupModel.getBuilderCompany() ? this.lookupModel.getBuilderCompany() : null;
    if(this.selectedProperty && this.selectedProperty.successPropertyImages) {
      this.successPropertyImages = this.selectedProperty.successPropertyImages;
    }
  }

  uploadAws(event: any, index: number): void {
    const mdlRef = this.modalService.open(ImageCropperComponent, { windowClass: 'signInForm'});
    mdlRef.componentInstance.imageChangedEvent = event;
    mdlRef.result.then((cropResp: {image: any, markDefault: boolean}) => {
      if(cropResp && cropResp.image) {
        const modalRef = this.modalService.open(UploadProgressComponent, { windowClass: 'signInForm' });
        modalRef.componentInstance.file = cropResp.image;
        modalRef.result.then((path: string) => {
          if (path) {
            if(this.successPropertyImages[index]) {
              this.successPropertyImages[index] = path;
            } else {
              const imageList = this.successPropertyImages.filter(item => item !== '');
              // if(cropResp.markDefault) {
              //   imageList.unshift(path);
              //   this.selectedProperty.propertyPreviewImage = path;
              // } else {
                imageList.push(path);
              //}
              if(imageList.length < 6) {
                const length = 6 - imageList.length;
                for(var i=0 ; i < length; i++) {
                  imageList.push('');
                }
              }
              this.successPropertyImages = imageList;
            }
          }
        });
      }
    });
  }

  submit(): void {
    let property = this.lookupModel.getBuilderCompany();
    property.successProjectsGallery = this.successPropertyImages;
    this.lookupModel.setBuilderCompany(property);
    this.showNextPage.emit(5);
  }
    

}
